module.exports = __webpack_public_path__ + "assets/img/function2.b8a1435c.png";